import { computed, nextTick, watch, type Ref } from 'vue';
import { useRoute } from 'vue-router';
import { DOCUMENT_TYPE_CATEGORY_ID } from '@/shared/lib';
import { QUALITY_RECORDS_ROOT_ITEM_ID, matrixNavigationItemId } from './useDocumentTypes';

export const QUALITY_RECORD_MATRIX_ROUTE_NAME = 'QualityRecordMatrix';

interface MatrixRouteNavigationTarget {
  selectedCategory: Ref<string>;
  setSelectedItem: (itemId: string) => void;
  addExpandedItem: (itemId: string) => void;
}

export function useMatrixRouteNavigation(target: MatrixRouteNavigationTarget) {
  const route = useRoute();

  const routePrefix = computed(() => {
    if (route.name !== QUALITY_RECORD_MATRIX_ROUTE_NAME) return null;
    const { prefix } = route.params;
    return typeof prefix === 'string' && prefix ? prefix : null;
  });

  async function syncFromRoute() {
    const prefix = routePrefix.value;
    if (!prefix) return;

    if (target.selectedCategory.value !== DOCUMENT_TYPE_CATEGORY_ID) {
      target.selectedCategory.value = DOCUMENT_TYPE_CATEGORY_ID;
      // Switching away from another category makes NavigationContent reset the shared tree in a
      // pre-flush watcher, which would erase a selection written in the same tick.
      await nextTick();
    }

    target.addExpandedItem(QUALITY_RECORDS_ROOT_ITEM_ID);
    target.setSelectedItem(matrixNavigationItemId(prefix));
  }

  watch(routePrefix, () => {
    void syncFromRoute();
  });

  return { syncFromRoute };
}
